import { createAsyncThunk } from '@reduxjs/toolkit';
import VacanyApi from '@infrastructure/vacancy-api';
import { getErrorPayload } from '@application/common/helpers/api-helper';
export const getVacancies = createAsyncThunk('vacancy/getAll', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await VacanyApi.getVacancies();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getVacancyById = createAsyncThunk('vacancy/getById', async (Id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await VacanyApi.getVacancyById(Id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const applyVacancy = createAsyncThunk('vacancy/apply', async (application, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await VacanyApi.applyVacancy(application);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const filterVacancies = createAsyncThunk('vacancy/filter', async (filterRequest, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await VacanyApi.filterVacancy(filterRequest);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
